<template>
<div>
  <v-text-field
    v-bind="computedProps"
    placeholder="自動採番"
    v-on="computedListeners">

    <template v-slot:append>
      <v-btn icon color="primary" dark elevation="0" small v-if="readonly == false">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" @click="kamotsuNoSync" v-on="on" tabindex="-1" dark elevation="0" small>
              <v-icon>mdi-sync</v-icon>
            </v-btn>
          </template>
          <span>入力されている貨物Noの情報を表示します<br>※押下後は取得した内容で上書きされます<br>&nbsp;&nbsp;編集中の情報は保存されません。</span>
        </v-tooltip>
      </v-btn>
      <v-btn icon color="primary" dark elevation="0" small>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="primary" v-bind="attrs" @click="onDialogButtonClick" v-on="on" tabindex="-1" dark elevation="0" small>
              <v-icon>mdi-magnify-plus</v-icon>
            </v-btn>
          </template>
          <span>貨物検索用ポップアップを表示します<br>※貨物選択後は選択した内容で上書きされます<br>&nbsp;&nbsp;編集中の情報は保存されません。</span>
        </v-tooltip>
      </v-btn>
    </template>
  </v-text-field>
  <th-kamotsu-no-search-dialog
    :showDialog="showDialog"
    @close="onDialogClosed"/>
</div>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VTextField } from 'vuetify/lib'

const ThKamotsuNoSearchDialog = () => import('@/components/ThKamotsuNoSearchDialog')

export default {
  name: 'ThKamotsuNoTextBox',
  extends: VTextField,
  mixins: [inputMixin],
  components: {
    ThKamotsuNoSearchDialog
  },
  props: {
    /**
     * 入力タイプ
     * @see controls.InputTypes
     */
    valueType: Number,
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能桁数
     */
    length: Number,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * 埋め込み文字
     */
    paddingChar: String,
    /**
     * 追加フォーマッタ
     */
    appendFormatter: Function,
    appendUnFormatter: Function
  },
  data: () => ({
    invalidMessage: '',
    innerValue: '',
    showDialog: false
  }),
  created () {
    this.innerValue = this.value
  },
  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    if (this.invalidMessage === undefined) {
      // this[controls.VALIDATE_METHOD]()
    }
  },
  watch: {
    value: function (n, o) {
      this.innerValue = n
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        value: this.innerValue,
        maxlength: this.length,
        // ackgroundColor: this.required ? controls.Colors.Required : '',
        class: this.required ? ' required-item' : this.class,
        type: 'text',
        hideDetails: 'auto',
        outlined: !this.isReadonly,
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
      this.$emit('blur', e)
    },
    onFocus: function (e) {
      if (typeof this.appendUnFormatter === 'function' && this.appendUnFormatter) {
        this.innerValue = this.appendUnFormatter(this.innerValue)
      }
      const elem = this.$el.querySelector('input')
      this.$nextTick().then(() => {
        if (elem) { elem.select() }
        this.$emit('focus', e)
      })
    },
    onDialogButtonClick: function (e) {
      this.showDialog = true
      console.log('dialog opend', e)
    },
    onDialogClosed: function (e) {
      console.log('dialog closed', e, this.showDialog)
      this.showDialog = false
      if (e === undefined) { return }
      this.innerValue = e.juchuNo
      this.kamotsuNoDialogSync()
    },
    /**
     * dialog選択値inputイベント
     * @event input
     * @type {Event}
     * this.$emit('input', this.innerValue)
     */
    kamotsuNoSync: function (e) {
      console.log(' **** XXXXX **** kamotsuNoSync', e, this.showDialog)
      this.$emit('kamotsuNoSync', this.innerValue)
    },
    /**
     * dialog選択値inputイベント
     * @event input
     * @type {Event}
     * this.$emit('input', this.innerValue)
     */
    kamotsuNoDialogSync: function (e) {
      console.log(' **** XXXXX **** kamotsuNoDialogSync', e, this.showDialog)
      this.$emit('kamotsuNoDialogSync', this.innerValue)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        length: this.length
      }
      console.log(this)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(this.valueType)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        console.log(target, f.name)
        const ret = f(target)
        console.log(target, f.name, ret)
        if (ret !== undefined) {
          this.invalidMessage = ret
          // this.$set(this, 'invalidMessage', ret)
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
      if (typeof this.appendFormatter === 'function' && this.appendFormatter) {
        this.innerValue = this.appendFormatter(this.innerValue)
        this.$emit('input', this.innerValue)
        console.log(controls.FORMAT_METHOD, this.innerValue)
      }
    }
  }
}
</script>
<style scoped>

</style>
